import React from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import "regenerator-runtime/runtime";

import createReduxStore from "./src/reducers";

exports.replaceRouterComponent = ({ history }) => {
	const store = createReduxStore(history);
	
	const ConnectedRouterWrapper = ({ children }) => (
		<Provider store={store}>
            <ConnectedRouter history={history}>
                <Switch>
                    {/* note: the below route removes trailing slashes */}
                    {/* this was put in place due to an issue with relative urls in markdown documents */}
                    <Route
                        exact
                        strict
                        path="/:path_without_trailing_slash+/"
                        render={props => (
                            <Redirect to={`/${props.match.params.path_without_trailing_slash}`} />
                        )}
                    />
                    
                    {children}
                </Switch>
			</ConnectedRouter>
		</Provider>
	);

	return ConnectedRouterWrapper;
}



// WEBPACK FOOTER //
// ./gatsby-browser.js